module.exports = __webpack_public_path__ + "static/media/tag.eb320fa3.png";